// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { CollisionSensitivity } from "./Shared.CollisionSensitivity.gen";
import { RelaySelection } from "./Shared.RelaySelection.gen";

export interface IFleetDefaults {
	id: string | undefined;

	organizationId: string | undefined;

	dateCreated: string | undefined;

	dateLastUpdated: string | undefined;

	minimumApproachSpeedMps: number;

	driverReactionTimeSeconds: number;

	sensitivity: CollisionSensitivity;

	lightsPulseSeconds: number;

	hornPulseSeconds: number;

	speedingEnabled: boolean;

	speedingThresholdMps: number;

	leftPassEnabled: boolean;

	rightPassEnabled: boolean;

	sidePassMinSpeedMps: number;

	leftPassLanes: number;

	rightPassLanes: number;

	tmaWidthMetres: number;

	tmaLengthMetres: number;

	radarEnabled: boolean;

	chirpConfigId: string | undefined;

	radarTrackerConfigId: string | undefined;

	videoTrackerConfigId: string | undefined;

	dvrRecordingEnabled: boolean;

	dvrResolutionX: number;

	dvrResolutionY: number;

	dvrFps: number;

	dvrBitrateBps: number;

	dvrRetentionHours: number;

	streamResolutionX: number;

	streamResolutionY: number;

	streamFps: number;

	streamBitrateBps: number;

	notifyEmailOnCollision: boolean;

	notifyEmailOnSpeeding: boolean;

	notifyEmailOnLeftPass: boolean;

	notifyEmailOnRightPass: boolean;

	notificationEmailAddresses: string | undefined;

	webRelayIpAddress: string | undefined;

	hornRelayNumber: number;

	lightsRelayNumber: number;

	hornRelayName: string | undefined;

	lightsRelayName: string | undefined;

	hornRelaySnoozable: boolean;

	lightsRelaySnoozable: boolean;

	collisionRelays: RelaySelection | number ;

	speedingRelays: RelaySelection | number ;

	leftPassRelays: RelaySelection | number ;

	rightPassRelays: RelaySelection | number ;

	driverMayToggleSpeeding: boolean;

	driverMayToggleLeftPass: boolean;

	driverMayToggleRightPass: boolean;

	driverMaySnoozeHorn: boolean;

	driverMaxSnoozeSeconds: number;

	driverMayRequestClips: boolean;

	driverMayChangeCollisionSettings: boolean;

	$type?: string | undefined;
}
export class FleetDefaults {
	constructor(data?: IFleetDefaults) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.dateLastUpdated) { this.dateLastUpdated = new Date(data.dateLastUpdated); }
	}

	id: string | undefined;

	organizationId: string | undefined;

	dateCreated: Date | undefined = new Date();

	dateLastUpdated: Date | undefined;

	minimumApproachSpeedMps: number = 0;

	driverReactionTimeSeconds: number = 0;

	sensitivity: CollisionSensitivity = 0;

	lightsPulseSeconds: number = 0;

	hornPulseSeconds: number = 0;

	speedingEnabled: boolean = false;

	speedingThresholdMps: number = 0;

	leftPassEnabled: boolean = false;

	rightPassEnabled: boolean = false;

	sidePassMinSpeedMps: number = 0;

	leftPassLanes: number = 0;

	rightPassLanes: number = 0;

	tmaWidthMetres: number = 0;

	tmaLengthMetres: number = 0;

	radarEnabled: boolean = false;

	chirpConfigId: string | undefined;

	radarTrackerConfigId: string | undefined;

	videoTrackerConfigId: string | undefined;

	dvrRecordingEnabled: boolean = false;

	dvrResolutionX: number = 0;

	dvrResolutionY: number = 0;

	dvrFps: number = 0;

	dvrBitrateBps: number = 0;

	dvrRetentionHours: number = 0;

	streamResolutionX: number = 0;

	streamResolutionY: number = 0;

	streamFps: number = 0;

	streamBitrateBps: number = 0;

	notifyEmailOnCollision: boolean = false;

	notifyEmailOnSpeeding: boolean = false;

	notifyEmailOnLeftPass: boolean = false;

	notifyEmailOnRightPass: boolean = false;

	notificationEmailAddresses: string | undefined;

	webRelayIpAddress: string | undefined;

	hornRelayNumber: number = 0;

	lightsRelayNumber: number = 0;

	hornRelayName: string | undefined;

	lightsRelayName: string | undefined;

	hornRelaySnoozable: boolean = false;

	lightsRelaySnoozable: boolean = false;

	collisionRelays: RelaySelection | number  = 0;

	speedingRelays: RelaySelection | number  = 0;

	leftPassRelays: RelaySelection | number  = 0;

	rightPassRelays: RelaySelection | number  = 0;

	driverMayToggleSpeeding: boolean = false;

	driverMayToggleLeftPass: boolean = false;

	driverMayToggleRightPass: boolean = false;

	driverMaySnoozeHorn: boolean = false;

	driverMaxSnoozeSeconds: number = 0;

	driverMayRequestClips: boolean = false;

	driverMayChangeCollisionSettings: boolean = false;

	static $type: string = "CoreApi.Models.FleetDefaults, ";
	$type?: string | undefined = FleetDefaults.$type;
}

